import { graphql } from '../graphql/generated';

export const SEND_LOCALLY_GENERATED_REQUEST_MUTATION = graphql(`
  mutation SendLocallyGeneratedRequest($requestId: ID!) {
    sendLocallyGeneratedRequest(requestId: $requestId) {
      id
      status
    }
  }
`);
